import * as env from "shared/env";
import { User } from "model/user";

// The MLS IDs tab on the Featured Listings page: with the MLS Setup redesign on, for users who may use today's MLS
// Setup page (not One CRM, or an admin).
export const hasMlsIdsTab = (user: User) => env.mlsSetupRefresh && (!user.permissions.oneCrm || user.admin);

// The old MLS Setup page sends these users to the MLS IDs tab instead. Users without the Featured Listings page
// keep the old page, so nobody loses their MLS IDs.
export const mlsSetupMovesToTab = (user: User) => hasMlsIdsTab(user) && !!user.permissions.listingResults;
